import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-8" data-testid="error-boundary">
          <div className="max-w-md text-center border border-zinc-300 bg-white p-10">
            <h1 className="font-heading font-black text-3xl tracking-tighter text-zinc-900">Something went wrong</h1>
            <p className="text-sm text-zinc-500 mt-3">An unexpected error occurred. Try reloading the page — your data is safe.</p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-button"
              className="mt-6 rounded-none bg-primary hover:bg-[#C2410C] text-white font-bold uppercase tracking-wider px-6 py-2.5 transition-colors duration-100"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
